import { getConfigApi } from '../config'
import { deleteFetch, getFetch, postFetch, putFetch } from 'utils/fetch'

const prefix = 'qa'

function getUrl(path = '') {
  return getConfigApi()[prefix] + '/' + path
}

export function getQA({ page = 1, itemPerPage = 2 }) {
  return getFetch(getUrl() + `?itemPerPage=${itemPerPage}&page=${page}`)
}

export function getQAByID(_id) {
  return getFetch(getUrl(`${_id}`))
}

export function createQA(data = {}) {
  return postFetch(getUrl(), data)
}

export function deleteQA(_id) {
  return deleteFetch(getUrl(`${_id}`))
}

export function updateQA(_id, data = {}) {
  return putFetch(getUrl(`${_id}`), data)
}

export default {
  getQA,
  createQA,
  deleteQA,
  updateQA,
  getQAByID
}



// WEBPACK FOOTER //
// ./src/api/QAApi.js